import { useState, useEffect } from 'react';
import useDebounce from 'library/hooks/use-debounce';
import Input from './new';
import {
  Container,
} from './styles';

const ColorSlider = ({ color, edgeColor, onSliderUpdate }) => {
  const [pointerLeft, setPointerLeft] = useState(100);
  const debouncedPointerLeft = useDebounce(pointerLeft, 200);

  useEffect(() => {
    onSliderUpdate(debouncedPointerLeft);
  }, [debouncedPointerLeft]);

  return (
    <Container>
      <Input
        left={pointerLeft}
        onChange={setPointerLeft}
        edgeColor={edgeColor}
        color={color}
      />
    </Container>
  );
};
export default ColorSlider;
